<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="$t('Please wait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cRetailOrderList' }">{{
          $t("Retail business management center")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Order details") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-rowl">
        <div class="tip_wrap shop_first">
          <div class="item">
            <h1>{{ $t("Order number") }}：</h1>
            <p>{{ dataItem.orderno }}</p>
          </div>
          <div class="item">
            <h1>{{ $t("Creation time") }}：</h1>
            <p>{{ dataItem.createdate | formatDate }}</p>
          </div>
          <div class="item">
            <h1>{{ $t("Sales specialist name") }}：</h1>
            <p>{{ dataItem.salerstr }}</p>
          </div>
          <div class="item">
            <h1>{{ $t("Order area") }}：</h1>
            <p>{{ COUNTRY.countryname_e }}</p>
          </div>
          <!-- <div class="item">
            <h1>{{ $t("Order source channel") }}：</h1>
            <p>{{ dataItem.channelidstr }}</p>
          </div> -->
        </div>
        <div class="tip_wrap shop_wrap">
          <div class="item shop_item">
            <div
              class="block flex-rowl"
              v-for="(item, index) in dataItem.goods"
              :key="index"
            >
              <div class="img">
                <el-image
                  style="width: 70px; height: 70px"
                  :src="item.img"
                  fit="cover"
                ></el-image>
              </div>
              <div class="content">
                <h1>
                  {{ $t("Product name") }}：<span>{{
                    item.multilingualCommodityname
                  }}</span>
                </h1>
                <h1>
                  {{ $t("Product ID") }}：<span>{{ item.id }}</span>
                </h1>
                <h1>
                  {{ $t("Product SKU") }}：<span>{{ item.sku }}</span>
                </h1>
                <h1>
                  <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
                    <span>{{ label }}</span>
                    <!-- <span>：{{ item.attrPrice }}/件</span> -->
                  </p>
                </h1>
                <h1>
                  {{ $t("Quantity of products") }}：<span>{{ item.num }}</span>
                </h1>
                <!-- <h1>
                价格小计：<span>{{ item.newPrice | formatPrice }}</span>
              </h1> -->
                <h1>
                  {{ $t("Product type") }}：<span>{{
                    $t("Main products")
                  }}</span>
                </h1>
                <template v-if="item.orderGood && item.orderGood.msgtype == 2">
                  <h1>
                    {{ $t("Recipient") }}：<span>{{
                      item.orderGood.msgman
                    }}</span>
                  </h1>
                  <h1>
                    {{ $t("Recipient contact information") }}：<span>{{
                      item.orderGood.msglink
                    }}</span>
                  </h1>
                  <h1>
                    {{
                      $t(
                        "Province/municipality directly under the Central Government"
                      )
                    }}：<span>{{ item.orderGood.msgaddr }}</span>
                  </h1>
                </template>
              </div>
            </div>
            <div
              class="block"
              v-for="(item, index) in dataItem.goods_pei"
              :key="index"
            >
              <h1>
                {{ $t("Product name") }}：<span>{{ item.commodityname }}</span>
              </h1>
              <h1>
                {{ $t("Product ID") }}：<span>{{ item.id }}</span>
              </h1>
              <h1>
                {{ $t("Product SKU") }}：<span>{{ item.sku }}</span>
              </h1>
              <h1>
                {{ $t("Quantity of products") }}：<span>{{ item.num }}</span>
              </h1>
              <h1>
                {{ $t("Product type") }}：<span>{{ $t("Accessories") }}</span>
              </h1>
            </div>
          </div>
        </div>
        <div class="tip_wrap">
          <div class="item">
            <h1>{{ $t("Recipient") }}：</h1>
            <p>{{ dataItem.truename }}</p>
          </div>
          <div class="item">
            <h1>{{ $t("Recipient contact information") }}：</h1>
            <p>{{ dataItem.cellphone }}</p>
          </div>
          <div class="item">
            <h1>
              {{
                $t(
                  "Province/municipality directly under the Central Government"
                )
              }}
            </h1>
            <p>{{ dataItem.addr }}</p>
          </div>
          <div class="item">
            <h1>{{ $t("Remarks information") }}：</h1>
            <p>
              {{
                dataItem.saler_note
                  ? dataItem.saler_note
                  : $t("No remarks information")
              }}
            </p>
          </div>
          <div class="item">
            <h1>{{ $t("Amount paid") }}：</h1>
            <p v-if="dataItem.totalpaynum_trans">
              <span>( {{ USERINFO.countryExrateObj.moneyslog }} ) </span>
              {{ dataItem.totalpaynum_trans | formatPrice }}
            </p>
            <p v-else>( {{ USERINFO.countryExrateObj.moneyslog }} ) 0.00</p>
          </div>
          <div class="item">
            <h1>{{ $t("Amount to be settled") }}：</h1>
            <p>
              ( {{ USERINFO.countryExrateObj.moneyslog }} )
              {{ dataItem.totalremain_trans | formatPrice }}
            </p>
          </div>
        </div>
        <div class="tip_wrap order_state_wrap">
          <div class="item">
            <h1>{{ $t("Order audit status") }}：</h1>
            <p class="red">
              {{
                dataItem.ischeck == 0
                  ? $t("Pending review")
                  : dataItem.ischeck == 1
                  ? $t("Approved")
                  : dataItem.ischeck == 2
                  ? $t("Failed the audit")
                  : ""
              }}
            </p>
          </div>
          <div class="item">
            <h1>{{ $t("Refund/return application status") }}：</h1>
            <p class="red">
              {{
                dataItem.isreturn === true
                  ? "YES"
                  : dataItem.isreturn === false
                  ? "NO"
                  : $t("None")
              }}
            </p>
          </div>
          <div class="item">
            <h1>{{ $t("Refund/return processing status") }}：</h1>
            <p class="red">
              {{ dataItem.returnstate ? dataItem.returnstate : $t("None") }}
            </p>
          </div>
          <div class="item">
            <h1>{{ $t("Order status") }}：</h1>
            <p class="red">
              {{
                dataItem.ordertalk == 1
                  ? $t("In progress")
                  : dataItem.ordertalk == 2
                  ? $t("Completed")
                  : dataItem.ordertalk == 3
                  ? $t("Closed")
                  : $t("None")
              }}
            </p>
          </div>
          <div
            class="item"
            v-if="type == 'cRetailOrderList' || type == 'cClientOrderList'"
          >
            <h1>{{ $t("Shipping Status") }}：</h1>
            <p class="red">
              {{
                dataItem.orderstate == "待发货"
                  ? $t("To be shipped")
                  : dataItem.orderstate
              }}
            </p>
          </div>
        </div>
        <div class="tip_wrap shop_last">
          <div class="item">
            <h1>{{ $t("Order screenshot attachment") }}：</h1>
          </div>
          <div class="upload_list flex-rowl">
            <div
              class="upload_box"
              v-for="(item, index) in picsList"
              :key="index"
              @mouseenter="enter(index)"
              @mouseleave="creenIndex = ''"
            >
              <div class="upload_item">
                <img :src="item" class="avatar" />
              </div>
              <div
                class="el-upload-list__item-actions flex-rowc"
                v-show="creenIndex === index"
                @click.stop="handlePictureCardPreview(item)"
              >
                <span><i class="iconfont icon-fangda"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl" v-if="isShow">
      <div class="btn" @click="handleGo('cPaymentPayList')">
        {{ $t("Payment registration") }}
      </div>
      <div class="btn" @click="handleGo('cPaymentReceiveGoods')">
        {{ $t("Receiving management") }}
      </div>
      <div class="btn" @click="handleToast">{{ $t("Return management") }}</div>

      <div class="return_txt" @click="handleReturn">←{{ $t("Return") }}</div>
    </div>
    <!--  主要内容 end -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getOrderListDetail } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cRetailOrderDetail",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      creenIndex: "",
      picsList: [],
      isShow: false,
      loading: false,
      dataItem: "",
      type: "",
      orderId: "",
      orderOpenid: "",
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "COUNTRY", "USERINFO"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, openid, type } = JSON.parse(res.jsondata);
        this.type = type;
        this.orderId = id;
        this.orderOpenid = openid;
        this.getOrderListDetail(id, openid);
      } else {
        this.$router.back();
      }
    },

    handleMultilingualName(dataList, key1, key2, key3, key4) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        if (countryid == 1) {
          v.multilingualCommodityname = v[key1];
        } else if (countryid == 8) {
          // 英文
          v.multilingualCommodityname = v[key2] ? v[key2] : v[key1];
        } else if (countryid == 2) {
          // 俄语
          v.multilingualCommodityname = v[key3]
            ? v[key3]
            : v[key2]
            ? v[key2]
            : v[key1];
        } else if (countryid == 4) {
          // 越语
          v.multilingualCommodityname = v[key4]
            ? v[key4]
            : v[key2]
            ? v[key2]
            : v[key1];
        }
      });
      return dataList;
    },
    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        let newGoods = [];
        if (this.isValidJsonString(newObj.goodsjson)) {
          newGoods = JSON.parse(newObj.goodsjson);
        } else {
          newGoods = [];
        }
        if (newObj.goods.length > 0) {
          newObj.goods.forEach((v1, index) => {
            v1.attr = v1.attr != "" ? JSON.parse(v1.attr) : v1.attr;
            if (newGoods != "") {
              v1.orderGood = newGoods[index];
              // 单件商品总价 (零售价 +/- 标签价) * 数量  后续加入折扣价针对于第一个商品
              let attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "-" + v1.orderGood.attrnum
                  : v1.orderGood.attrnum;

              v1.attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? "¥" + 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "- ¥" + v1.orderGood.attrnum
                  : "+ ¥" + v1.orderGood.attrnum;
              v1.newPrice = calculator(calculator(v1.price).add(attrPrice))
                .multiply(v1.num)
                .toNumber();
            } else {
              v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
            }
          });
          this.handleMultilingualName(
            newObj.goods,
            "commodityname",
            "commodityname_e",
            "commodityname_y",
            "commodityname_m"
          );
        }
        if (newObj.goods_pei.length > 0) {
          newObj.goods_pei.forEach((v1) => {
            v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
          });
        }

        this.picsList = newObj.pics ? newObj.pics.split(",") : "";
        this.dataItem = newObj;
        this.loading = false;
        this.isShow = true;
      });
    },

    isValidJsonString(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (error) {
        return false;
      }
    },

    // 大图预览
    handlePictureCardPreview(item) {
      this.dialogImageUrl = item;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning(this.$t("Opening soon"));
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleGo(name, state) {
      let { dataItem, orderId, orderOpenid } = this;
      // if (type == "cPaymentList" && dataItem.ischeck != 1) {
      // this.$message.warning(this.$t('Opening soon'));
      // } else {
      this.encryptstringadd(name, {
        orderno: dataItem.orderno,
        orderId,
        orderOpenid,
        state,
      });
      // }

      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}/${this.type}`);
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_container {
    align-items: flex-start;
    flex-flow: wrap;
    padding: 39px 20px 80px 70px;
    height: 65vh;
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        // flex-shrink: 0;
        width: calc(35% / 2);
        // &:first-child {
        //   flex-shrink: 0;
        //   width: 30%;
        // }
        &.shop_first {
          width: 13%;
        }
        &.shop_wrap {
          flex-shrink: 0;
          width: 23%;
          margin: 0 2% 0 2%;
        }
        &.order_state_wrap {
          flex-shrink: 0;
          width: 13%;
          margin: 0 2% 0 2%;
        }
        &.shop_last {
          width: 25%;
        }
        .item {
          margin-bottom: 15px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
            // white-space: nowrap;
          }
          &.shop_item {
            font-size: 14px;
            h1 {
              font-size: 16px;
              span {
                color: #6e6e6e;
                font-size: 14px;
                white-space: pre-wrap;
                word-break: break-all;
              }
            }
            .block {
              margin-bottom: 20px;
              align-items: flex-start;

              .img {
                width: 70px;
                flex-shrink: 0;
                margin-right: 10px;
              }
            }
          }
          p {
            &.red {
              color: red;
            }
          }
          &.pay_item {
            p {
              margin-bottom: 5px;
            }
          }
        }
        .upload_list {
          flex-wrap: wrap;
          .upload_box {
            width: calc((100% - 25px) / 4);
            height: 100px;
            margin-right: 5px;
            margin-bottom: 10px;
            border: 1px dashed #c0ccda;
            border-radius: 5px;
            cursor: pointer;
            position: relative;
            &:nth-child(4n) {
              margin-right: 0;
            }
            .upload_item {
              height: 100%;
              width: 100%;
              position: relative;
              img {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }
            .custom-upload {
              .el-upload--picture-card {
                // width: 120px;
                // height: 120px;
              }
            }
            .el-upload-list__item-actions span {
              &:last-child {
                margin-left: 0;
              }
            }

            &:last-child {
              margin-right: 0;
            }
          }
          .custom_upload {
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            width: 148px;
            height: 148px;
            cursor: pointer;
            line-height: 146px;
            vertical-align: top;
            cursor: pointer;
            input {
              opacity: 0;
              width: 100%;
              height: 100%;
              position: relative;
              z-index: 10;
              cursor: pointer;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              z-index: 9;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
    }
  }
  .form_footer {
    .btn {
      min-width: 130px;
      width: auto;
      padding: 0 10px;
      box-sizing: border-box;
      &:nth-child(2n) {
        margin: 0 30px;
      }
      &.disabled {
        background: #a6a6a6;
      }
    }
  }
}
</style>